import { db } from "./firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import templateQuestions from "./templateQuestions";
import { expandTemplate } from "./expandTemplate";

export async function seedExpandedTemplates() {
  const ref = collection(db, "questions");

  for (const template of templateQuestions) {
    const expanded = expandTemplate(template, 20);

    for (const question of expanded) {
      try {
        await addDoc(ref, {
          ...question,
          createdAt: serverTimestamp(),
        });
        console.log("✅ Uploaded:", question.question);
      } catch (err) {
        console.error("❌ Failed:", err.message);
      }
    }
  }
}
